const DepoimentosSection = ({ embedRef }) => (
  <section className="testimonials">
    <div style={{ textAlign: 'center', marginTop: 15 + 'px' }}>
      <h2>O que os pais dizem sobre nós</h2>
    </div>
    <div className="testimonial-cards">
      <div className="testimonial-card">
        <div className="testimonial-content">
            <p>"Excelente Colégio. Moderno e com uma educação próxima para as crianças."</p>
            <div className="testimonial-author">
                <div className="author-initials">DS</div>
                <div className="author-details">
                    <strong>Daniella Santana</strong>
                    <span>Mãe de aluno</span>
                </div>
            </div>
        </div>
      </div>
      <div className="testimonial-card">
        <div className="testimonial-content">
            <p>"Até agora sem reclamações! Gostei muito da escola e principalmente do acolhimento e educação da coordenação."</p>
            <div className="testimonial-author">
                <div className="author-initials">ES</div>
                <div className="author-details">
                    <strong>Elaine Souza</strong>
                    <span>Mãe de aluno</span>
                </div>
            </div>
        </div>
      </div>
    </div>
    <div ref={embedRef} style={{ display: 'flex', flexWrap: 'wrap', justifyContent: 'center', marginTop: 20 + 'px', gap: 30 + 'px'}}>
          <blockquote
            className="instagram-media"
            data-instgrm-permalink="https://www.instagram.com/reel/C9U9dKasVxT/?utm_source=ig_embed"
            data-instgrm-version="14"
          />
          <blockquote
            className="instagram-media"
            data-instgrm-permalink="https://www.instagram.com/reel/C9F35tTsrmT/?utm_source=ig_embed"
            data-instgrm-version="14"
          />
      </div>
  </section>
);

export default DepoimentosSection;
